module.exports = __webpack_public_path__ + "img/67800.0ffdae04.jpg";